class ProvenResult extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.statNumbers = this.querySelectorAll('.stat-number');
    if (!this.statNumbers.length) return;

    this.setupObserver();
  }

  setupObserver() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.animateNumbers();
          this.observer.disconnect(); // run once
        }
      },
      {
        threshold: 0.3,
      }
    );

    this.observer.observe(this);
  }

  animateNumbers() {
    this.statNumbers.forEach((el) => {
      const finalValue = parseInt(el.textContent, 10);
      if (isNaN(finalValue)) return;

      el.textContent = '0%';

      this.countUp(el, finalValue, 1200);
    });
  }

  countUp(el, target, duration) {
      const start = performance.now();

      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      const animate = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);

      const value = eased * target;

      el.textContent = `${value.toFixed(0)}%`;

      if (progress < 1) {
          requestAnimationFrame(animate);
      } else {
          el.textContent = `${target}%`;
      }
      };

      requestAnimationFrame(animate);
  }


  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('proven-result', ProvenResult);
